/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserEmergencyContactResponse
 */
export interface UserEmergencyContactResponse {
    /**
     * 
     * @type {string}
     * @memberof UserEmergencyContactResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UserEmergencyContactResponse
     */
    role?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserEmergencyContactResponse
     */
    phone_number?: string | null;
}

/**
 * Check if a given object implements the UserEmergencyContactResponse interface.
 */
export function instanceOfUserEmergencyContactResponse(value: object): value is UserEmergencyContactResponse {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function UserEmergencyContactResponseFromJSON(json: any): UserEmergencyContactResponse {
    return UserEmergencyContactResponseFromJSONTyped(json, false);
}

export function UserEmergencyContactResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserEmergencyContactResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'role': json['role'] == null ? undefined : json['role'],
        'phone_number': json['phone_number'] == null ? undefined : json['phone_number'],
    };
}

export function UserEmergencyContactResponseToJSON(json: any): UserEmergencyContactResponse {
    return UserEmergencyContactResponseToJSONTyped(json, false);
}

export function UserEmergencyContactResponseToJSONTyped(value?: UserEmergencyContactResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'role': value['role'],
        'phone_number': value['phone_number'],
    };
}

